import { History } from "history";

import { PaginateQuery } from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";
import {
  BannerDto,
  CreateBannerRequest,
  UpdateBannerRequest,
} from "../../interfaces/banner";

//#region Get Banners

export const GET_BANNERS = "GET_BANNERS";
export const GET_BANNERS_SUCCESS: any = "GET_BANNERS_SUCCESS";
export const GET_BANNERS_ERROR: any = "GET_BANNERS_ERROR";

export interface GetBannersAction {
  type: typeof GET_BANNERS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetBannersSuccessAction {
  type: typeof GET_BANNERS_SUCCESS;
  payload: Paginated<BannerDto>;
}

export interface GetBannersErrorAction {
  type: typeof GET_BANNERS_ERROR;
  payload: any;
}
//#endregion

//#region Get Banner

export const GET_BANNER = "GET_BANNER";
export const GET_BANNER_SUCCESS: any = "GET_BANNER_SUCCESS";
export const GET_BANNER_ERROR: any = "GET_BANNER_ERROR";

export interface GetBannerAction {
  type: typeof GET_BANNER;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetBannerSuccessAction {
  type: typeof GET_BANNER_SUCCESS;
  payload: BannerDto;
}

export interface GetBannerErrorAction {
  type: typeof GET_BANNER_ERROR;
  payload: any;
}
//#endregion

//#region Add Banner

export const ADD_BANNER = "ADD_BANNER";
export const ADD_BANNER_SUCCESS: any = "ADD_BANNER_SUCCESS";
export const ADD_BANNER_ERROR: any = "ADD_BANNER_ERROR";

export interface AddBannerAction {
  type: typeof ADD_BANNER;
  payload: {
    request: CreateBannerRequest;
    history: History;
  };
}

export interface AddBannerSuccessAction {
  type: typeof ADD_BANNER_SUCCESS;
  payload: null;
}

export interface AddBannerErrorAction {
  type: typeof ADD_BANNER_ERROR;
  payload: any;
}
//#endregion

//#region Update Banner

export const UPDATE_BANNER = "UPDATE_BANNER";
export const UPDATE_BANNER_SUCCESS: any = "UPDATE_BANNER_SUCCESS";
export const UPDATE_BANNER_ERROR: any = "UPDATE_BANNER_ERROR";

export interface UpdateBannerAction {
  type: typeof UPDATE_BANNER;
  payload: {
    id: string;
    request: UpdateBannerRequest;
    history: History;
  };
}

export interface UpdateBannerSuccessAction {
  type: typeof UPDATE_BANNER_SUCCESS;
  payload: null;
}

export interface UpdateBannerErrorAction {
  type: typeof UPDATE_BANNER_ERROR;
  payload: any;
}
//#endregion

//#region Delete Banner

export const DELETE_BANNER_CONSENT: any = "DELETE_BANNER_CONSENT";
export const DELETE_BANNER = "DELETE_BANNER";
export const DELETE_BANNER_SUCCESS: any = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_ERROR: any = "DELETE_BANNER_ERROR";

export interface DeleteBannerConsentAction {
  type: typeof DELETE_BANNER_CONSENT;
  payload: string;
}

export interface DeleteBannerAction {
  type: typeof DELETE_BANNER;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteBannerSuccessAction {
  type: typeof DELETE_BANNER_SUCCESS;
  payload: null;
}

export interface DeleteBannerErrorAction {
  type: typeof DELETE_BANNER_ERROR;
  payload: any;
}
//#endregion

//#region Upload Banner Image

export const UPLOAD_BANNER_IMAGE = "UPLOAD_BANNER_IMAGE";
export const UPLOAD_BANNER_IMAGE_SUCCESS: any = "UPLOAD_BANNER_IMAGE_SUCCESS";
export const UPLOAD_BANNER_IMAGE_ERROR: any = "UPLOAD_BANNER_IMAGE_ERROR";

export interface UploadBannerImageAction {
  type: typeof UPLOAD_BANNER_IMAGE;
  payload: {
    file: File;
    history: History;
    bannerId?: string;
  };
}
export interface UploadBannerImageSuccessAction {
  type: typeof UPLOAD_BANNER_IMAGE_SUCCESS;
  payload: MediaDto;
}

export interface UploadBannerImageErrorAction {
  type: typeof UPLOAD_BANNER_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region add edit banner modal
export const TOGGLE_ADD_EDIT_BANNER_MODAL: any = "TOGGLE_ADD_EDIT_BANNER_MODAL";
export interface ToggleAddEditBannerModalAction {
  type: typeof TOGGLE_ADD_EDIT_BANNER_MODAL;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetBannerAction
  | GetBannerSuccessAction
  | GetBannerErrorAction
  | AddBannerAction
  | AddBannerSuccessAction
  | AddBannerErrorAction
  | UpdateBannerAction
  | UpdateBannerSuccessAction
  | UpdateBannerErrorAction
  | DeleteBannerAction
  | DeleteBannerSuccessAction
  | DeleteBannerErrorAction
  | UploadBannerImageAction
  | UploadBannerImageSuccessAction
  | UploadBannerImageErrorAction
  | ToggleAddEditBannerModalAction;
